import { useCallback, useRef } from 'react';

export function useFireOnce() {
  const hasFired = useRef<boolean>(false);

  return useCallback(
    (callback: () => void) => {
      if (!hasFired.current) {
        hasFired.current = true;
        callback();
      }
    },
    [hasFired],
  );
}
